export const boundsOld = {
  assumptions: [
    {
      display: false,
      id: 0,
      name: "Cr_recovery_percent",
      status: true,
      value: 90,
    },
    {
      display: false,
      id: 1,
      name: "Fe_recovery_percent",
      status: true,
      value: 95,
    },
    {
      display: false,
      id: 2,
      name: "Cr_plus_Fe_assumption_percent",
      status: true,
      value: 88,
    },
    {
      display: false,
      id: 3,
      name: "Silicon_assumption_factor",
      status: true,
      value: 3.5,
    },
    {
      display: false,
      id: 4,
      name: "P_to_slag_assumption_percent",
      status: true,
      value: 8,
    },
    {
      display: false,
      id: 5,
      name: "P_fume_loss_assumption_percent",
      status: true,
      value: 10,
    },
    {
      display: false,
      id: 6,
      name: "S_to_slag_assumption_percent",
      status: true,
      value: 30,
    },
    {
      display: false,
      id: 7,
      name: "S_fume_loss_assumption_percent",
      status: true,
      value: 60,
    },
    {
      display: false,
      id: 8,
      name: "Carbon_assumption_factor",
      status: true,
      value: 7.5,
    },
    {
      display: false,
      id: 9,
      name: "Cr2O3_reduction_factor",
      status: true,
      value: 0.346153846153846,
    },
    {
      display: false,
      id: 10,
      name: "FeO_reduction_factor",
      status: true,
      value: 0.166666666,
    },
    {
      display: false,
      id: 11,
      name: "SiO2_reduction_factor",
      status: true,
      value: 0.857142857142857,
    },
    {
      display: false,
      id: 12,
      name: "Fe2O3_reduction_factor",
      status: true,
      value: 0.225,
    },
    {
      display: false,
      id: 13,
      name: "SiO2_in_slag_percent",
      status: true,
      value: 30,
    },
    {
      display: false,
      id: 14,
      name: "Others_in_slag_percent",
      status: true,
      value: 70,
    },
    {
      display: false,
      id: 15,
      name: "Silicon_in_alloy_factor",
      status: true,
      value: 2.142857,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 16,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 17,
      name: "FeO",
      status: true,
      value: 7.83,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 18,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 19,
      name: "SiO2",
      status: true,
      value: 47.8,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 20,
      name: "MgO",
      status: true,
      value: 1.6,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 21,
      name: "Al2O3",
      status: true,
      value: 27.2,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 22,
      name: "CaO",
      status: true,
      value: 5.8,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 23,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 24,
      name: "FeO",
      status: true,
      value: 4.77,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 25,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 26,
      name: "SiO2",
      status: true,
      value: 56.8,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 27,
      name: "MgO",
      status: true,
      value: 2.6,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 28,
      name: "Al2O3",
      status: true,
      value: 19.9,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 29,
      name: "CaO",
      status: true,
      value: 3.4,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 30,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 31,
      name: "FeO",
      status: true,
      value: 9.8,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 32,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 33,
      name: "SiO2",
      status: true,
      value: 50.4,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 34,
      name: "MgO",
      status: true,
      value: 3.2,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 35,
      name: "Al2O3",
      status: true,
      value: 26.9,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 36,
      name: "CaO",
      status: true,
      value: 2.5,
    },
  ].map((el, idx) => {
    el.id = idx + 1;
    return el;
  }),
  constraints: [
    {
      category: "LUMPS",
      id: "LUMPS5",
      name: "max_allowed_Lumps",
      status: true,
      value: 22,
    },
    {
      category: "CHIPS",
      id: "CHIPS4",
      name: "max_allowed_Chips",
      status: true,
      value: 20,
    },
    {
      id: 2,
      name: "percent_SiO2_aim",
      status: true,
      value: 83,
    },
    {
      display: false,
      id: 5,
      name: "Cr_aim",
      status: true,
      value: 60,
    },
    {
      display: false,
      id: 7,
      name: "P_input_aim",
      status: true,
      value: 0,
    },
    {
      display: false,
      id: 9,
      name: "S_input_aim",
      status: true,
      value: 0,
    },
    {
      display: true,
      id: 12,
      name: "MgO_by_Al2O3_input_aim",
      status: true,
      value: 1.09,
    },
    {
      display: false,
      id: 15,
      name: "basicity_input_aim",
      status: true,
      value: 1.07,
    },
    {
      display: false,
      id: 18,
      name: "Cr_by_Fe_ore_aim",
      status: true,
      value: 2.5,
    },
    {
      display: false,
      id: 19,
      name: "input_CaO_aim",
      status: true,
      value: 23,
    },
    {
      display: true,
      id: 20,
      name: "LUMPS_plus_CHIPS_aim",
      status: true,
      value: 37.5,
    },
    {
      display: true,
      id: 21,
      name: "FBL_percent_aim",
      status: true,
      value: 12.5,
    },
    {
      display: true,
      id: 23,
      name: "COKE_CO_percent_aim",
      status: true,
      value: 85,
    },
    {
      display: true,
      id: 25,
      name: "COAL_AN_percent_aim",
      status: true,
      value: 15,
    },
  ].map((el, idx) => {
    el.id = idx + 1;
    return el;
  }),
  controllers: [
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: "TC1",
      name: "population_size",
      status: true,
      value: 100,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: "TC3",
      name: "mutation_probability",
      status: true,
      value: 0.3,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: "TC4",
      name: "mutation_extent",
      status: true,
      value: 10,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: "TC5",
      name: "generations",
      status: true,
      value: 120,
    },
    // {
    //   // LUMPS_BIN: 2,
    //   // LUMPS_LMG_PERCENT: 0.17,
    //   // LUMPS_LMG_TOLERANCE_PERCENT: 0.03,
    //   // LUMPS_LG_PERCENT: 0.04,
    //   // LUMPS_LG_TOLERANCE_PERCENT: 0.03,
    // },
    {
      category: "LUMPS",
      id: "LUMPS1",
      name: "LUMPS_BIN",
      status: true,
      value: 2,
    },
    {
      category: "LUMPS",
      id: "LUMPS2",
      name: "LUMPS_LMG_PERCENT",
      status: true,
      value: 0.17,
    },
    {
      category: "LUMPS",
      id: "LUMPS4",
      name: "LUMPS_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 0.03,
    },
    {
      category: "LUMPS",
      id: "LUMPS3",
      name: "LUMPS_LG_PERCENT",
      status: true,
      value: 0.04,
    },
    {
      category: "LUMPS",
      id: "LUMPS5",
      name: "LUMPS_LG_TOLERANCE_PERCENT",
      status: true,
      value: 0.03,
    },
    // {
    //   // CHIPS_BIN: 1,
    //   // CHIPS_LMG_PERCENT: 0.2,
    //   // CHIPS_LMG_TOLERANCE_PERCENT: 0.02,
    //   // CHIPS_LG_PERCENT: 0.15,
    //   // CHIPS_LG_TOLERANCE_PERCENT: 0.03,
    // },
    {
      category: "CHIPS",
      id: "CHIPS1",
      name: "CHIPS_BIN",
      status: true,
      value: 1,
    },
    {
      category: "CHIPS",
      id: "CHIPS2",
      name: "CHIPS_LMG_PERCENT",
      status: true,
      value: 0.2,
    },
    {
      category: "CHIPS",
      id: "CHIPS5",
      name: "CHIPS_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 0.02,
    },
    {
      category: "CHIPS",
      id: "CHIPS3",
      name: "CHIPS_LG_PERCENT",
      status: true,
      value: 0.15,
    },
    {
      category: "CHIPS",
      id: "CHIPS4",
      name: "CHIPS_LG_TOLERANCE_PERCENT",
      status: true,
      value: 0.03,
    },

    // {
    //   // FBL_BIN: 2,
    //   // FBL_HG_PERCENT: 0.05,
    //   // FBL_HG_TOLERANCE_PERCENT: 0.02,
    //   // FBL_HMG_PERCENT: 0.05,
    //   // FBL_HMG_TOLERANCE_PERCENT: 0.02,
    //   // FBL_LMG_PERCENT: 0.05,
    //   // FBL_LMG_TOLERANCE_PERCENT: 0.02,
    //   // FBL_LG_PERCENT: 0.05,
    //   // FBL_LG_TOLERANCE_PERCENT: 0.02,
    // },
    {
      category: "FBL",
      id: "FBL1",
      name: "FBL_BIN",
      status: true,
      value: 1,
    },
    {
      category: "FBL",
      id: "FBL2",
      name: "FBL_HG_PERCENT",
      status: true,
      value: 0.05,
    },
    {
      category: "FBL",
      id: "FBL3",
      name: "FBL_HG_TOLERANCE_PERCENT",
      status: true,
      value: 0.02,
    },
    {
      category: "FBL",
      id: "FBL4",
      name: "FBL_HMG_PERCENT",
      status: true,
      value: 0.05,
    },
    {
      category: "FBL",
      id: "FBL5",
      name: "FBL_HMG_TOLERANCE_PERCENT",
      status: true,
      value: 0.02,
    },
    {
      category: "FBL",
      id: "FBL6",
      name: "FBL_LMG_PERCENT",
      status: true,
      value: 0.05,
    },
    {
      category: "FBL",
      id: "FBL7",
      name: "FBL_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 0.02,
    },
    {
      category: "FBL",
      id: "FBL8",
      name: "FBL_LG_PERCENT",
      status: true,
      value: 0.05,
    },
    {
      category: "FBL",
      id: "FBL9",
      name: "FBL_LG_TOLERANCE_PERCENT",
      status: true,
      value: 0.02,
    },

    // {
    //   COMPOSITE_BQT_BIN: 1,
    //   NORMAL_BQT_BIN: 2,
    //   BQT_HG_COMP_PERCENT: 0.21,
    //   BQT_HG_COMP_TOLERANCE_PERCENT: 0.015,
    //   BQT_HMG_COMP_PERCENT: 0.15,
    //   BQT_HMG_COMP_TOLERANCE_PERCENT: 0.02,
    //   BQT_LMG_COMP_PERCENT: 0.15,
    //   BQT_LMG_COMP_TOLERANCE_PERCENT: 0.03,
    //   BQT_LG_COMP_PERCENT: 0.15,
    //   BQT_LG_COMP_TOLERANCE_PERCENT: 0.05,
    //   BQT_HG_PERCENT: 0.15,
    //   BQT_HG_TOLERANCE_PERCENT: 0.05,
    //   BQT_HMG_PERCENT: 0.1,
    //   BQT_HMG_TOLERANCE_PERCENT: 0.03,
    //   BQT_LMG_PERCENT: 0.1,
    //   BQT_LMG_TOLERANCE_PERCENT: 0.05,
    //   BQT_LG_PERCENT: 0.15,
    //   BQT_LG_TOLERANCE_PERCENT: 0.03,
    // },
    {
      category: "BQT",
      id: "BQT1",
      name: "COMPOSITE_BQT_BIN",
      status: true,
      value: 1,
    },
    {
      category: "BQT",
      id: "BQT2",
      name: "NORMAL_BQT_BIN",
      status: true,
      value: 2,
    },
    {
      category: "BQT",
      id: "BQT3",
      name: "BQT_HG_COMP_PERCENT",
      status: true,
      value: 0.21,
    },
    {
      category: "BQT",
      id: "BQT4",
      name: "BQT_HG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 0.015,
    },
    {
      category: "BQT",
      id: "BQT5",
      name: "BQT_HMG_COMP_PERCENT",
      status: true,
      value: 0.15,
    },
    {
      category: "BQT",
      id: "BQT6",
      name: "BQT_HMG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 0.02,
    },
    {
      category: "BQT",
      id: "BQT7",
      name: "BQT_LMG_COMP_PERCENT",
      status: true,
      value: 0.15,
    },
    {
      category: "BQT",
      id: "BQT8",
      name: "BQT_LMG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 0.03,
    },
    {
      category: "BQT",
      id: "BQT9",
      name: "BQT_LG_COMP_PERCENT",
      status: true,
      value: 0.15,
    },
    {
      category: "BQT",
      id: "BQT10",
      name: "BQT_LG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 0.05,
    },
    {
      category: "BQT",
      id: "BQT11",
      name: "BQT_HG_PERCENT",
      status: true,
      value: 0.15,
    },
    {
      category: "BQT",
      id: "BQT12",
      name: "BQT_HG_TOLERANCE_PERCENT",
      status: true,
      value: 0.05,
    },
    {
      category: "BQT",
      id: "BQT13",
      name: "BQT_HMG_PERCENT",
      status: true,
      value: 0.01,
    },
    {
      category: "BQT",
      id: "BQT14",
      name: "BQT_HMG_TOLERANCE_PERCENT",
      status: true,
      value: 0.03,
    },
    {
      category: "BQT",
      id: "BQT15",
      name: "BQT_LMG_PERCENT",
      status: true,
      value: 0.1,
    },
    {
      category: "BQT",
      id: "BQT16",
      name: "BQT_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 0.05,
    },
    {
      category: "BQT",
      id: "BQT17",
      name: "BQT_LG_PERCENT",
      status: true,
      value: 0.15,
    },
    {
      category: "BQT",
      id: "BQT18",
      name: "BQT_LG_TOLERANCE_PERCENT",
      status: true,
      value: 0.03,
    },
  ].map((el, idx) => {
    el.id = idx + 1;
    return el;
  }),
  weightage_factors: [
    {
      display: false,
      id: 4,
      name: "FC_balance_percent_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 5,
      name: "SiO2_imbalance_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 6,
      name: "percent_SiO2_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 7,
      name: "reductant_purchase_cost_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 9,
      name: "Cr_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 11,
      name: "P_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 13,
      name: "S_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 17,
      name: "basicity_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 19,
      name: "Cr_by_Fe_ore_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 20,
      name: "too_much_CaO_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 22,
      name: "Lumps_plus_chips_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 24,
      name: "FBL_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 25,
      name: "grade_balance_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 26,
      name: "Max_Lumps_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 27,
      name: "Max_Chips_ff",
      status: true,
      value: 1,
    },
  ].map((el, idx) => {
    el.id = idx + 1;
    return el;
  }),
};

let steps = {
  LUMPS_STEP2: 40,
  CHIPS_STEP2: 60,
  LMG_LUMPS_STEP3: 60,
  LG_LUMPS_STEP3: 40,
  LMG_CHIPS_STEP3: 50,
  LG_CHIPS_STEP3: 50,
  HG_BQT_STEP3: 27.5,
  HMG_BQT_STEP3: 27.5,
  LG_BQT_STEP3: 22.5,
  LMG_BQT_STEP3: 22.5,
  HG_COMP_BQT_STEP3: 7.5,
  HMG_COMP_BQT_STEP3: 7.5,
  LG_COMP_BQT_STEP3: 0,
  LMG_COMP_BQT_STEP3: 0,
};

export const bounds = {
  assumptions: [
    {
      display: false,
      id: 1,
      name: "Cr_recovery_percent",
      status: true,
      value: 90,
    },
    {
      display: false,
      id: 2,
      name: "Fe_recovery_percent",
      status: true,
      value: 95,
    },
    {
      display: false,
      id: 3,
      name: "Cr_plus_Fe_assumption_percent",
      status: true,
      value: 88,
    },
    {
      display: false,
      id: 4,
      name: "Silicon_assumption_factor",
      status: true,
      value: 3.5,
    },
    {
      display: false,
      id: 5,
      name: "P_to_slag_assumption_percent",
      status: true,
      value: 8,
    },
    {
      display: false,
      id: 6,
      name: "P_fume_loss_assumption_percent",
      status: true,
      value: 10,
    },
    {
      display: false,
      id: 7,
      name: "S_to_slag_assumption_percent",
      status: true,
      value: 30,
    },
    {
      display: false,
      id: 8,
      name: "S_fume_loss_assumption_percent",
      status: true,
      value: 60,
    },
    {
      display: false,
      id: 9,
      name: "Carbon_assumption_factor",
      status: true,
      value: 7.5,
    },
    {
      display: false,
      id: 10,
      name: "Cr2O3_reduction_factor",
      status: true,
      value: 0.346153846153846,
    },
    {
      display: false,
      id: 11,
      name: "FeO_reduction_factor",
      status: true,
      value: 0.166666666,
    },
    {
      display: false,
      id: 12,
      name: "SiO2_reduction_factor",
      status: true,
      value: 0.857142857142857,
    },
    {
      display: false,
      id: 13,
      name: "Fe2O3_reduction_factor",
      status: true,
      value: 0.225,
    },
    {
      display: false,
      id: 14,
      name: "SiO2_in_slag_percent",
      status: true,
      value: 30,
    },
    {
      display: false,
      id: 15,
      name: "Others_in_slag_percent",
      status: true,
      value: 70,
    },
    {
      display: false,
      id: 16,
      name: "Silicon_in_alloy_factor",
      status: true,
      value: 2.142857,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 17,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 18,
      name: "FeO",
      status: true,
      value: 7.83,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 19,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 20,
      name: "SiO2",
      status: true,
      value: 47.8,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 21,
      name: "MgO",
      status: true,
      value: 1.6,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 22,
      name: "Al2O3",
      status: true,
      value: 27.2,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 23,
      name: "CaO",
      status: true,
      value: 5.8,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 24,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 25,
      name: "FeO",
      status: true,
      value: 4.77,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 26,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 27,
      name: "SiO2",
      status: true,
      value: 56.8,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 28,
      name: "MgO",
      status: true,
      value: 2.6,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 29,
      name: "Al2O3",
      status: true,
      value: 19.9,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 30,
      name: "CaO",
      status: true,
      value: 3.4,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 31,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 32,
      name: "FeO",
      status: true,
      value: 9.8,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 33,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 34,
      name: "SiO2",
      status: true,
      value: 50.4,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 35,
      name: "MgO",
      status: true,
      value: 3.2,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 36,
      name: "Al2O3",
      status: true,
      value: 26.9,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 37,
      name: "CaO",
      status: true,
      value: 2.5,
    },
  ],
  constraints: [
    {
      category: "LUMPS",
      id: 1,
      name: "max_allowed_Lumps",
      status: true,
      value: 20,
    },
    {
      category: "CHIPS",
      id: 2,
      name: "max_allowed_Chips",
      status: true,
      value: 25,
    },
    {
      id: 3,
      name: "percent_SiO2_aim",
      status: true,
      value: 83,
    },
    {
      display: false,
      id: 4,
      name: "Cr_aim",
      status: true,
      value: 60,
    },
    {
      display: false,
      id: 5,
      name: "P_input_aim",
      status: true,
      value: 0,
    },
    {
      display: false,
      id: 6,
      name: "S_input_aim",
      status: true,
      value: 0,
    },
    {
      display: true,
      id: 7,
      name: "MgO_by_Al2O3_input_aim",
      status: true,
      value: 1.09,
    },
    {
      display: false,
      id: 8,
      name: "basicity_input_aim",
      status: true,
      value: 1.07,
    },
    {
      display: false,
      id: 9,
      name: "Cr_by_Fe_ore_aim",
      status: true,
      value: 2.5,
    },
    {
      display: false,
      id: 10,
      name: "input_CaO_aim",
      status: true,
      value: 23,
    },
    {
      display: true,
      id: 11,
      name: "LUMPS_plus_CHIPS_aim",
      status: true,
      value: 42.5,
    },
    {
      display: true,
      id: 12,
      name: "FBL_percent_aim",
      status: true,
      value: 10,
    },
    {
      display: true,
      id: 13,
      name: "COKE_CO_percent_aim",
      status: true,
      value: 85,
    },
    {
      display: true,
      id: 14,
      name: "COAL_AN_percent_aim",
      status: true,
      value: 15,
    },
  ],
  controllers: [
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 1,
      name: "population_size",
      status: true,
      value: 100,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 2,
      name: "mutation_probability",
      status: true,
      value: 0.3,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 3,
      name: "mutation_extent",
      status: true,
      value: 10,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 4,
      name: "generations",
      status: true,
      value: 100,
    },
    {
      category: "LUMPS",
      id: 5,
      name: "LUMPS_BIN",
      status: true,
      value: 1,
    },
    {
      category: "LUMPS",
      id: 6,
      name: "LUMPS_LMG_PERCENT",
      status: true,
      value: 10.2,
    },
    {
      category: "LUMPS",
      id: 7,
      name: "LUMPS_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 5,
    },
    {
      category: "LUMPS",
      id: 8,
      name: "LUMPS_LG_PERCENT",
      status: true,
      value: 6.800000000000001,
    },
    {
      category: "LUMPS",
      id: 9,
      name: "LUMPS_LG_TOLERANCE_PERCENT",
      status: true,
      value: 1,
    },
    {
      category: "CHIPS",
      id: 10,
      name: "CHIPS_BIN",
      status: true,
      value: 1,
    },
    {
      category: "CHIPS",
      id: 11,
      name: "CHIPS_LMG_PERCENT",
      status: true,
      value: 12.75,
    },
    {
      category: "CHIPS",
      id: 12,
      name: "CHIPS_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 5,
    },
    {
      category: "CHIPS",
      id: 13,
      name: "CHIPS_LG_PERCENT",
      status: true,
      value: 12.75,
    },
    {
      category: "CHIPS",
      id: 14,
      name: "CHIPS_LG_TOLERANCE_PERCENT",
      status: true,
      value: 1,
    },
    {
      category: "FBL",
      id: 15,
      name: "FBL_BIN",
      status: true,
      value: 1,
    },
    {
      category: "FBL",
      id: 16,
      name: "FBL_HG_PERCENT",
      status: true,
      value: 12.5,
    },
    {
      category: "FBL",
      id: 17,
      name: "FBL_HG_TOLERANCE_PERCENT",
      status: true,
      value: 5,
    },
    {
      category: "FBL",
      id: 18,
      name: "FBL_HMG_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 19,
      name: "FBL_HMG_TOLERANCE_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 20,
      name: "FBL_LMG_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 21,
      name: "FBL_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 22,
      name: "FBL_LG_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 23,
      name: "FBL_LG_TOLERANCE_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 24,
      name: "COMPOSITE_BQT_BIN",
      status: true,
      value: 1,
    },
    {
      category: "BQT",
      id: 25,
      name: "NORMAL_BQT_BIN",
      status: true,
      value: 2,
    },
    {
      category: "BQT",
      id: 26,
      name: "BQT_HG_COMP_PERCENT",
      status: true,
      value: 7.5,
    },
    {
      category: "BQT",
      id: 27,
      name: "BQT_HG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 2,
    },
    {
      category: "BQT",
      id: 28,
      name: "BQT_HMG_COMP_PERCENT",
      status: true,
      value: 7.5,
    },
    {
      category: "BQT",
      id: 29,
      name: "BQT_HMG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 2,
    },
    {
      category: "BQT",
      id: 30,
      name: "BQT_LMG_COMP_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 31,
      name: "BQT_LMG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 2,
    },
    {
      category: "BQT",
      id: 32,
      name: "BQT_LG_COMP_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 33,
      name: "BQT_LG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 5,
    },
    {
      category: "BQT",
      id: 34,
      name: "BQT_HG_PERCENT",
      status: true,
      value: 11.103125,
    },
    {
      category: "BQT",
      id: 35,
      name: "BQT_HG_TOLERANCE_PERCENT",
      status: true,
      value: 5,
    },
    {
      category: "BQT",
      id: 36,
      name: "BQT_HMG_PERCENT",
      status: true,
      value: 11.103125,
    },
    {
      category: "BQT",
      id: 37,
      name: "BQT_HMG_TOLERANCE_PERCENT",
      status: true,
      value: 1,
    },
    {
      category: "BQT",
      id: 38,
      name: "BQT_LMG_PERCENT",
      status: true,
      value: 9.084375,
    },
    {
      category: "BQT",
      id: 39,
      name: "BQT_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 5,
    },
    {
      category: "BQT",
      id: 40,
      name: "BQT_LG_PERCENT",
      status: true,
      value: 9.084375,
    },
    {
      category: "BQT",
      id: 41,
      name: "BQT_LG_TOLERANCE_PERCENT",
      status: true,
      value: 0,
    },
  ],
  weightage_factors: [
    {
      display: false,
      id: 1,
      name: "FC_balance_percent_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 2,
      name: "SiO2_imbalance_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 3,
      name: "percent_SiO2_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 4,
      name: "reductant_purchase_cost_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 5,
      name: "Cr_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 6,
      name: "P_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 7,
      name: "S_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 8,
      name: "basicity_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 9,
      name: "Cr_by_Fe_ore_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 10,
      name: "too_much_CaO_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 11,
      name: "Lumps_plus_chips_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 12,
      name: "FBL_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 13,
      name: "grade_balance_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 14,
      name: "Max_Lumps_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 15,
      name: "Max_Chips_ff",
      status: true,
      value: 1,
    },
  ],
  steps: Object.keys(steps).map((el, idx) => {
    let newEl = {
      id: idx,
      name: el,
      status: true,
      value: steps[el],
    };
    return newEl;
  }),
};

export const boundsKg = {
  assumptions: [
    {
      display: false,
      id: 1,
      name: "Cr_recovery_percent",
      status: true,
      value: 90,
    },
    {
      display: false,
      id: 2,
      name: "Fe_recovery_percent",
      status: true,
      value: 95,
    },
    {
      display: false,
      id: 3,
      name: "Cr_plus_Fe_assumption_percent",
      status: true,
      value: 88,
    },
    {
      display: false,
      id: 4,
      name: "Silicon_assumption_factor",
      status: true,
      value: 3.5,
    },
    {
      display: false,
      id: 5,
      name: "P_to_slag_assumption_percent",
      status: true,
      value: 8,
    },
    {
      display: false,
      id: 6,
      name: "P_fume_loss_assumption_percent",
      status: true,
      value: 10,
    },
    {
      display: false,
      id: 7,
      name: "S_to_slag_assumption_percent",
      status: true,
      value: 30,
    },
    {
      display: false,
      id: 8,
      name: "S_fume_loss_assumption_percent",
      status: true,
      value: 60,
    },
    {
      display: false,
      id: 9,
      name: "Carbon_assumption_factor",
      status: true,
      value: 7.5,
    },
    {
      display: false,
      id: 10,
      name: "Cr2O3_reduction_factor",
      status: true,
      value: 0.346153846153846,
    },
    {
      display: false,
      id: 11,
      name: "FeO_reduction_factor",
      status: true,
      value: 0.166666666,
    },
    {
      display: false,
      id: 12,
      name: "SiO2_reduction_factor",
      status: true,
      value: 0.857142857142857,
    },
    {
      display: false,
      id: 13,
      name: "Fe2O3_reduction_factor",
      status: true,
      value: 0.225,
    },
    {
      display: false,
      id: 14,
      name: "SiO2_in_slag_percent",
      status: true,
      value: 30,
    },
    {
      display: false,
      id: 15,
      name: "Others_in_slag_percent",
      status: true,
      value: 70,
    },
    {
      display: false,
      id: 16,
      name: "Silicon_in_alloy_factor",
      status: true,
      value: 2.142857,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 17,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 18,
      name: "FeO",
      status: true,
      value: 7.83,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 19,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 20,
      name: "SiO2",
      status: true,
      value: 47.8,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 21,
      name: "MgO",
      status: true,
      value: 1.6,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 22,
      name: "Al2O3",
      status: true,
      value: 27.2,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 23,
      name: "CaO",
      status: true,
      value: 5.8,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 24,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 25,
      name: "FeO",
      status: true,
      value: 4.77,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 26,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 27,
      name: "SiO2",
      status: true,
      value: 56.8,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 28,
      name: "MgO",
      status: true,
      value: 2.6,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 29,
      name: "Al2O3",
      status: true,
      value: 19.9,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 30,
      name: "CaO",
      status: true,
      value: 3.4,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 31,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 32,
      name: "FeO",
      status: true,
      value: 9.8,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 33,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 34,
      name: "SiO2",
      status: true,
      value: 50.4,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 35,
      name: "MgO",
      status: true,
      value: 3.2,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 36,
      name: "Al2O3",
      status: true,
      value: 26.9,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 37,
      name: "CaO",
      status: true,
      value: 2.5,
    },
  ],
  constraints: [
    {
      category: "LUMPS",
      id: 1,
      name: "max_allowed_Lumps",
      status: true,
      value: 20,
    },
    {
      category: "CHIPS",
      id: 2,
      name: "max_allowed_Chips",
      status: true,
      value: 25,
    },
    {
      id: 3,
      name: "percent_SiO2_aim",
      status: true,
      value: 83,
    },
    {
      display: false,
      id: 4,
      name: "Cr_aim",
      status: true,
      value: 60,
    },
    {
      display: false,
      id: 5,
      name: "P_input_aim",
      status: true,
      value: 0,
    },
    {
      display: false,
      id: 6,
      name: "S_input_aim",
      status: true,
      value: 0,
    },
    {
      display: true,
      id: 7,
      name: "MgO_by_Al2O3_input_aim",
      status: true,
      value: 1.09,
    },
    {
      display: false,
      id: 8,
      name: "basicity_input_aim",
      status: true,
      value: 1.07,
    },
    {
      display: false,
      id: 9,
      name: "Cr_by_Fe_ore_aim",
      status: true,
      value: 2.5,
    },
    {
      display: false,
      id: 10,
      name: "input_CaO_aim",
      status: true,
      value: 23,
    },
    {
      display: true,
      id: 11,
      name: "LUMPS_plus_CHIPS_aim",
      status: true,
      value: 40,
    },
    {
      display: true,
      id: 12,
      name: "FBL_percent_aim",
      status: true,
      value: 10,
    },
    {
      display: true,
      id: 13,
      name: "COKE_CO_percent_aim",
      status: true,
      value: 85,
    },
    {
      display: true,
      id: 14,
      name: "COAL_AN_percent_aim",
      status: true,
      value: 15,
    },
  ],
  controllers: [
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 1,
      name: "population_size",
      status: true,
      value: 100,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 2,
      name: "mutation_probability",
      status: true,
      value: 0.3,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 3,
      name: "mutation_extent",
      status: true,
      value: 10,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 4,
      name: "generations",
      status: true,
      value: 100,
    },
    {
      category: "LUMPS",
      id: 5,
      name: "LUMPS_BIN",
      status: true,
      value: 1,
    },
    {
      category: "LUMPS",
      id: 6,
      name: "LUMPS_LMG_PERCENT",
      status: true,
      value: 16.000000000000004,
    },
    {
      category: "LUMPS",
      id: 7,
      name: "LUMPS_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "LUMPS",
      id: 8,
      name: "LUMPS_LG_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "LUMPS",
      id: 9,
      name: "LUMPS_LG_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "CHIPS",
      id: 10,
      name: "CHIPS_BIN",
      status: true,
      value: 1,
    },
    {
      category: "CHIPS",
      id: 11,
      name: "CHIPS_LMG_PERCENT",
      status: true,
      value: 24,
    },
    {
      category: "CHIPS",
      id: 12,
      name: "CHIPS_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "CHIPS",
      id: 13,
      name: "CHIPS_LG_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "CHIPS",
      id: 14,
      name: "CHIPS_LG_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "FBL",
      id: 15,
      name: "FBL_BIN",
      status: true,
      value: 1,
    },
    {
      category: "FBL",
      id: 16,
      name: "FBL_HG_PERCENT",
      status: true,
      value: 10,
    },
    {
      category: "FBL",
      id: 17,
      name: "FBL_HG_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "FBL",
      id: 18,
      name: "FBL_HMG_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 19,
      name: "FBL_HMG_TOLERANCE_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 20,
      name: "FBL_LMG_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 21,
      name: "FBL_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 22,
      name: "FBL_LG_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 23,
      name: "FBL_LG_TOLERANCE_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 24,
      name: "COMPOSITE_BQT_BIN",
      status: true,
      value: 1,
    },
    {
      category: "BQT",
      id: 25,
      name: "NORMAL_BQT_BIN",
      status: true,
      value: 2,
    },
    {
      category: "BQT",
      id: 26,
      name: "BQT_HG_COMP_PERCENT",
      status: true,
      value: 15,
    },
    {
      category: "BQT",
      id: 27,
      name: "BQT_HG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "BQT",
      id: 28,
      name: "BQT_HMG_COMP_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 29,
      name: "BQT_HMG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "BQT",
      id: 30,
      name: "BQT_LMG_COMP_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 31,
      name: "BQT_LMG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "BQT",
      id: 32,
      name: "BQT_LG_COMP_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 33,
      name: "BQT_LG_COMP_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "BQT",
      id: 34,
      name: "BQT_HG_PERCENT",
      status: true,
      value: 23.375000000000004,
    },
    {
      category: "BQT",
      id: 35,
      name: "BQT_HG_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "BQT",
      id: 36,
      name: "BQT_HMG_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 37,
      name: "BQT_HMG_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "BQT",
      id: 38,
      name: "BQT_LMG_PERCENT",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 39,
      name: "BQT_LMG_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
    {
      category: "BQT",
      id: 40,
      name: "BQT_LG_PERCENT",
      status: true,
      value: 19.125,
    },
    {
      category: "BQT",
      id: 41,
      name: "BQT_LG_TOLERANCE_PERCENT",
      status: true,
      value: 3,
    },
  ].map((el) => {
    if (el.name.indexOf("BIN") !== -1) {
      return el;
    }
    if (el.category !== "TOP_CONTROLLERS") {
      el.value = +(el.value * 10).toFixed(2);
      if (el.name.indexOf("_TOLERANCE_PERCENT") !== -1) {
        el.name = el.name.replace(/_TOLERANCE_PERCENT/g, "_TOLERANCE");
      } else if (el.name.indexOf("_PERCENT") !== -1) {
        el.name = el.name.replace(/_PERCENT/g, "_TOTAL");
      }
    }
    return el;
  }),
  steps: [
    {
      id: 0,
      name: "LUMPS_STEP2",
      status: true,
      value: 40,
      displayName: "LUMPS",
      description: "Out of total LUMPS plus CHIPS aim",
    },
    {
      id: 1,
      name: "CHIPS_STEP2",
      status: true,
      value: 60,
      displayName: "CHIPS",
      description: "Out of total Lumps & Chips Aim",
    },
    {
      id: 2,
      name: "LMG_LUMPS_STEP3",
      status: true,
      value: 60,
      displayName: "LMG_LUMPS",
      description: "Out of total Lumps Qty of Burden",
    },
    {
      id: 3,
      name: "LG_LUMPS_STEP3",
      status: true,
      value: 40,
      displayName: "LG_LUMPS",
      description: "Out of total Lumps Qty of Burden",
    },
    {
      id: 4,
      name: "LMG_CHIPS_STEP3",
      status: true,
      value: 50,
      displayName: "LMG_CHIPS",
      description: "Out of total Chips Qty of Burden",
    },
    {
      id: 5,
      name: "LG_CHIPS_STEP3",
      status: true,
      value: 50,
      displayName: "LG_CHIPS",
      description: "Out of total Chips Qty of Burden",
    },
    {
      id: 6,
      name: "HG_BQT_STEP3",
      status: true,
      value: 27.5,
      displayName: "HG_BQT",
      description: "Out of total BRIQUETTE Qty of Burden",
    },
    {
      id: 7,
      name: "HMG_BQT_STEP3",
      status: true,
      value: 27.5,
      displayName: "HMG_BQT",
      description: "Out of total BRIQUETTE Qty of Burden",
    },
    {
      id: 8,
      name: "LG_BQT_STEP3",
      status: true,
      value: 22.5,
      displayName: "LG_BQT",
      description: "Out of total BRIQUETTE Qty of Burden",
    },
    {
      id: 9,
      name: "LMG_BQT_STEP3",
      status: true,
      value: 22.5,
      displayName: "LMG_BQT",
      description: "Out of total BRIQUETTE Qty of Burden",
    },
    {
      id: 10,
      name: "HG_COMP_BQT_STEP3",
      status: true,
      value: 7.5,
      displayName: "HG_COMP_BQT",
      description: "Out of total ore mix",
    },
    {
      id: 11,
      name: "HMG_COMP_BQT_STEP3",
      status: true,
      value: 7.5,
      displayName: "HMG_COMP_BQT",
      description: "Out of total ore mix",
    },
    {
      id: 12,
      name: "LG_COMP_BQT_STEP3",
      status: true,
      value: 0,
      displayName: "LG_COMP_BQT",
      description: "Out of total ore mix",
    },
    {
      id: 13,
      name: "LMG_COMP_BQT_STEP3",
      status: true,
      value: 0,
      displayName: "LMG_COMP_BQT",
      description: "Out of total ore mix",
    },
  ].map((el) => {
    if (el.name.indexOf("STEP1") !== -1) {
      el.stepNumber = 1;
    } else if (el.name.indexOf("STEP2") !== -1) {
      el.stepNumber = 2;
    } else if (el.name.indexOf("STEP3") !== -1) {
      el.stepNumber = 3;
    }
    return el;
  }),
  weightage_factors: [
    {
      display: false,
      id: 1,
      name: "FC_balance_percent_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 2,
      name: "SiO2_imbalance_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 3,
      name: "percent_SiO2_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 4,
      name: "reductant_purchase_cost_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 5,
      name: "Cr_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 6,
      name: "P_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 7,
      name: "S_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 8,
      name: "basicity_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 9,
      name: "Cr_by_Fe_ore_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 10,
      name: "too_much_CaO_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 11,
      name: "Lumps_plus_chips_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 12,
      name: "FBL_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 13,
      name: "grade_balance_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 14,
      name: "Max_Lumps_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 15,
      name: "Max_Chips_ff",
      status: true,
      value: 1,
    },
  ],
};

export const oct_20_1 = {
  assumptions: [
    {
      display: false,
      id: 1,
      name: "Cr_recovery_percent",
      status: true,
      value: 90,
    },
    {
      display: false,
      id: 2,
      name: "Fe_recovery_percent",
      status: true,
      value: 95,
    },
    {
      display: false,
      id: 3,
      name: "Cr_plus_Fe_assumption_percent",
      status: true,
      value: 88,
    },
    {
      display: false,
      id: 4,
      name: "Silicon_assumption_factor",
      status: true,
      value: 3.5,
    },
    {
      display: false,
      id: 5,
      name: "P_to_slag_assumption_percent",
      status: true,
      value: 8,
    },
    {
      display: false,
      id: 6,
      name: "P_fume_loss_assumption_percent",
      status: true,
      value: 10,
    },
    {
      display: false,
      id: 7,
      name: "S_to_slag_assumption_percent",
      status: true,
      value: 30,
    },
    {
      display: false,
      id: 8,
      name: "S_fume_loss_assumption_percent",
      status: true,
      value: 60,
    },
    {
      display: false,
      id: 9,
      name: "Carbon_assumption_factor",
      status: true,
      value: 7.5,
    },
    {
      display: false,
      id: 10,
      name: "Cr2O3_reduction_factor",
      status: true,
      value: 0.346153846153846,
    },
    {
      display: false,
      id: 11,
      name: "FeO_reduction_factor",
      status: true,
      value: 0.166666666,
    },
    {
      display: false,
      id: 12,
      name: "SiO2_reduction_factor",
      status: true,
      value: 0.857142857142857,
    },
    {
      display: false,
      id: 13,
      name: "Fe2O3_reduction_factor",
      status: true,
      value: 0.225,
    },
    {
      display: false,
      id: 14,
      name: "SiO2_in_slag_percent",
      status: true,
      value: 30,
    },
    {
      display: false,
      id: 15,
      name: "Others_in_slag_percent",
      status: true,
      value: 70,
    },
    {
      display: false,
      id: 16,
      name: "Silicon_in_alloy_factor",
      status: true,
      value: 2.142857,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 17,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 18,
      name: "FeO",
      status: true,
      value: 7.83,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 19,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 20,
      name: "SiO2",
      status: true,
      value: 47.8,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 21,
      name: "MgO",
      status: true,
      value: 1.6,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 22,
      name: "Al2O3",
      status: true,
      value: 27.2,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 23,
      name: "CaO",
      status: true,
      value: 5.8,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 24,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 25,
      name: "FeO",
      status: true,
      value: 4.77,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 26,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 27,
      name: "SiO2",
      status: true,
      value: 56.8,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 28,
      name: "MgO",
      status: true,
      value: 2.6,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 29,
      name: "Al2O3",
      status: true,
      value: 19.9,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 30,
      name: "CaO",
      status: true,
      value: 3.4,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 31,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 32,
      name: "FeO",
      status: true,
      value: 9.8,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 33,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 34,
      name: "SiO2",
      status: true,
      value: 50.4,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 35,
      name: "MgO",
      status: true,
      value: 3.2,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 36,
      name: "Al2O3",
      status: true,
      value: 26.9,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 37,
      name: "CaO",
      status: true,
      value: 2.5,
    },
  ],
  constraints: [
    {
      category: "LUMPS",
      id: 1,
      name: "max_allowed_Lumps",
      status: true,
      value: 20,
    },
    {
      category: "CHIPS",
      id: 2,
      name: "max_allowed_Chips",
      status: true,
      value: 25,
    },
    {
      id: 3,
      name: "percent_SiO2_aim",
      status: true,
      value: 83,
    },
    {
      display: false,
      id: 4,
      name: "Cr_aim",
      status: true,
      value: 60,
    },
    {
      display: false,
      id: 5,
      name: "P_input_aim",
      status: true,
      value: 0,
    },
    {
      display: false,
      id: 6,
      name: "S_input_aim",
      status: true,
      value: 0,
    },
    {
      display: true,
      id: 7,
      name: "MgO_by_Al2O3_input_aim",
      status: true,
      value: 1.09,
    },
    {
      display: false,
      id: 8,
      name: "basicity_input_aim",
      status: true,
      value: 1.07,
    },
    {
      display: false,
      id: 9,
      name: "Cr_by_Fe_ore_aim",
      status: true,
      value: 2.5,
    },
    {
      display: false,
      id: 10,
      name: "input_CaO_aim",
      status: true,
      value: 23,
    },
    {
      display: true,
      id: 11,
      name: "LUMPS_plus_CHIPS_aim",
      status: true,
      value: 42.5,
    },
    {
      display: true,
      id: 12,
      name: "FBL_percent_aim",
      status: true,
      value: 7.5,
    },
    {
      display: true,
      id: 13,
      name: "COKE_CO_percent_aim",
      status: true,
      value: 85,
    },
    {
      display: true,
      id: 14,
      name: "COAL_AN_percent_aim",
      status: true,
      value: 15,
    },
  ],
  controllers: [
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 1,
      name: "population_size",
      status: true,
      value: 100,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 2,
      name: "mutation_probability",
      status: true,
      value: 0.3,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 3,
      name: "mutation_extent",
      status: true,
      value: 10,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 4,
      name: "generations",
      status: true,
      value: 100,
    },
    {
      category: "LUMPS",
      id: 5,
      name: "LUMPS_BIN",
      status: true,
      value: 2,
    },
    {
      category: "LUMPS",
      id: 6,
      name: "LUMPS_LMG_TOTAL",
      status: true,
      value: 160,
    },
    {
      category: "LUMPS",
      id: 7,
      name: "LUMPS_LMG_TOLERANCE",
      status: true,
      value: 10,
    },
    {
      category: "LUMPS",
      id: 8,
      name: "LUMPS_LG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "LUMPS",
      id: 9,
      name: "LUMPS_LG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "CHIPS",
      id: 10,
      name: "CHIPS_BIN",
      status: true,
      value: 1,
    },
    {
      category: "CHIPS",
      id: 11,
      name: "CHIPS_LMG_TOTAL",
      status: true,
      value: 240,
    },
    {
      category: "CHIPS",
      id: 12,
      name: "CHIPS_LMG_TOLERANCE",
      status: true,
      value: 10,
    },
    {
      category: "CHIPS",
      id: 13,
      name: "CHIPS_LG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "CHIPS",
      id: 14,
      name: "CHIPS_LG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "FBL",
      id: 15,
      name: "FBL_BIN",
      status: true,
      value: 1,
    },
    {
      category: "FBL",
      id: 16,
      name: "FBL_HG_TOTAL",
      status: true,
      value: 100,
    },
    {
      category: "FBL",
      id: 17,
      name: "FBL_HG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "FBL",
      id: 18,
      name: "FBL_HMG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 19,
      name: "FBL_HMG_TOLERANCE",
      status: true,
      value: 10,
    },
    {
      category: "FBL",
      id: 20,
      name: "FBL_LMG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 21,
      name: "FBL_LMG_TOLERANCE",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 22,
      name: "FBL_LG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 23,
      name: "FBL_LG_TOLERANCE",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 24,
      name: "COMPOSITE_BQT_BIN",
      status: true,
      value: 1,
    },
    {
      category: "BQT",
      id: 25,
      name: "NORMAL_BQT_BIN",
      status: true,
      value: 2,
    },
    {
      category: "BQT",
      id: 26,
      name: "BQT_HG_COMP_TOTAL",
      status: true,
      value: 150,
    },
    {
      category: "BQT",
      id: 27,
      name: "BQT_HG_COMP_TOLERANCE",
      status: true,
      value: 10,
    },
    {
      category: "BQT",
      id: 28,
      name: "BQT_HMG_COMP_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 29,
      name: "BQT_HMG_COMP_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 30,
      name: "BQT_LMG_COMP_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 31,
      name: "BQT_LMG_COMP_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 32,
      name: "BQT_LG_COMP_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 33,
      name: "BQT_LG_COMP_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 34,
      name: "BQT_HG_TOTAL",
      status: true,
      value: 233.75,
    },
    {
      category: "BQT",
      id: 35,
      name: "BQT_HG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 36,
      name: "BQT_HMG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 37,
      name: "BQT_HMG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 38,
      name: "BQT_LMG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 39,
      name: "BQT_LMG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 40,
      name: "BQT_LG_TOTAL",
      status: true,
      value: 191.25,
    },
    {
      category: "BQT",
      id: 41,
      name: "BQT_LG_TOLERANCE",
      status: true,
      value: 30,
    },
  ],
  steps: [
    {
      description: "Out of total LUMPS plus CHIPS aim",
      displayName: "LUMPS",
      id: 0,
      name: "LUMPS_STEP2",
      status: true,
      stepNumber: 2,
      value: 50,
    },
    {
      description: "Out of total Lumps & Chips Aim",
      displayName: "CHIPS",
      id: 1,
      name: "CHIPS_STEP2",
      status: true,
      stepNumber: 2,
      value: 50,
    },
    {
      description: "Out of total Lumps Qty of Burden",
      displayName: "LMG_LUMPS",
      id: 2,
      name: "LMG_LUMPS_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total Lumps Qty of Burden",
      displayName: "LG_LUMPS",
      id: 3,
      name: "LG_LUMPS_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total Chips Qty of Burden",
      displayName: "LMG_CHIPS",
      id: 4,
      name: "LMG_CHIPS_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total Chips Qty of Burden",
      displayName: "LG_CHIPS",
      id: 5,
      name: "LG_CHIPS_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total BRIQUETTE Qty of Burden",
      displayName: "HG_BQT",
      id: 6,
      name: "HG_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total BRIQUETTE Qty of Burden",
      displayName: "HMG_BQT",
      id: 7,
      name: "HMG_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total BRIQUETTE Qty of Burden",
      displayName: "LG_BQT",
      id: 8,
      name: "LG_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total BRIQUETTE Qty of Burden",
      displayName: "LMG_BQT",
      id: 9,
      name: "LMG_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total ore mix",
      displayName: "HG_COMP_BQT",
      id: 10,
      name: "HG_COMP_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 10,
    },
    {
      description: "Out of total ore mix",
      displayName: "HMG_COMP_BQT",
      id: 11,
      name: "HMG_COMP_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 10,
    },
    {
      description: "Out of total ore mix",
      displayName: "LG_COMP_BQT",
      id: 12,
      name: "LG_COMP_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 0,
    },
    {
      description: "Out of total ore mix",
      displayName: "LMG_COMP_BQT",
      id: 13,
      name: "LMG_COMP_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 0,
    },
  ],
  weightage_factors: [
    {
      display: false,
      id: 1,
      name: "FC_balance_percent_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 2,
      name: "SiO2_imbalance_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 3,
      name: "percent_SiO2_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 4,
      name: "reductant_purchase_cost_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 5,
      name: "Cr_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 6,
      name: "P_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 7,
      name: "S_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 8,
      name: "basicity_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 9,
      name: "Cr_by_Fe_ore_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 10,
      name: "too_much_CaO_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 11,
      name: "Lumps_plus_chips_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 12,
      name: "FBL_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 13,
      name: "grade_balance_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 14,
      name: "Max_Lumps_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 15,
      name: "Max_Chips_ff",
      status: true,
      value: 1,
    },
  ],
};

export const oct_20_2 = {
  assumptions: [
    {
      display: false,
      id: 1,
      name: "Cr_recovery_percent",
      status: true,
      value: 90,
    },
    {
      display: false,
      id: 2,
      name: "Fe_recovery_percent",
      status: true,
      value: 95,
    },
    {
      display: false,
      id: 3,
      name: "Cr_plus_Fe_assumption_percent",
      status: true,
      value: 88,
    },
    {
      display: false,
      id: 4,
      name: "Silicon_assumption_factor",
      status: true,
      value: 3.5,
    },
    {
      display: false,
      id: 5,
      name: "P_to_slag_assumption_percent",
      status: true,
      value: 8,
    },
    {
      display: false,
      id: 6,
      name: "P_fume_loss_assumption_percent",
      status: true,
      value: 10,
    },
    {
      display: false,
      id: 7,
      name: "S_to_slag_assumption_percent",
      status: true,
      value: 30,
    },
    {
      display: false,
      id: 8,
      name: "S_fume_loss_assumption_percent",
      status: true,
      value: 60,
    },
    {
      display: false,
      id: 9,
      name: "Carbon_assumption_factor",
      status: true,
      value: 7.5,
    },
    {
      display: false,
      id: 10,
      name: "Cr2O3_reduction_factor",
      status: true,
      value: 0.346153846153846,
    },
    {
      display: false,
      id: 11,
      name: "FeO_reduction_factor",
      status: true,
      value: 0.166666666,
    },
    {
      display: false,
      id: 12,
      name: "SiO2_reduction_factor",
      status: true,
      value: 0.857142857142857,
    },
    {
      display: false,
      id: 13,
      name: "Fe2O3_reduction_factor",
      status: true,
      value: 0.225,
    },
    {
      display: false,
      id: 14,
      name: "SiO2_in_slag_percent",
      status: true,
      value: 30,
    },
    {
      display: false,
      id: 15,
      name: "Others_in_slag_percent",
      status: true,
      value: 70,
    },
    {
      display: false,
      id: 16,
      name: "Silicon_in_alloy_factor",
      status: true,
      value: 2.142857,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 17,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 18,
      name: "FeO",
      status: true,
      value: 7.83,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 19,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 20,
      name: "SiO2",
      status: true,
      value: 47.8,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 21,
      name: "MgO",
      status: true,
      value: 1.6,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 22,
      name: "Al2O3",
      status: true,
      value: 27.2,
    },
    {
      category: "COKE_CH",
      display: false,
      id: 23,
      name: "CaO",
      status: true,
      value: 5.8,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 24,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 25,
      name: "FeO",
      status: true,
      value: 4.77,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 26,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 27,
      name: "SiO2",
      status: true,
      value: 56.8,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 28,
      name: "MgO",
      status: true,
      value: 2.6,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 29,
      name: "Al2O3",
      status: true,
      value: 19.9,
    },
    {
      category: "COKE_CO",
      display: false,
      id: 30,
      name: "CaO",
      status: true,
      value: 3.4,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 31,
      name: "Cr2O3",
      status: true,
      value: 0,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 32,
      name: "FeO",
      status: true,
      value: 9.8,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 33,
      name: "Fe2O3",
      status: true,
      value: 0,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 34,
      name: "SiO2",
      status: true,
      value: 50.4,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 35,
      name: "MgO",
      status: true,
      value: 3.2,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 36,
      name: "Al2O3",
      status: true,
      value: 26.9,
    },
    {
      category: "COAL_AN",
      display: false,
      id: 37,
      name: "CaO",
      status: true,
      value: 2.5,
    },
  ],
  constraints: [
    // {
    //   category: "LUMPS",
    //   id: 1,
    //   name: "max_allowed_Lumps",
    //   status: true,
    //   value: 20,
    // },
    // {
    //   category: "CHIPS",
    //   id: 2,
    //   name: "max_allowed_Chips",
    //   status: true,
    //   value: 25,
    // },
    {
      id: 3,
      name: "percent_SiO2_aim",
      status: true,
      value: 83,
    },
    {
      display: false,
      id: 4,
      name: "Cr_aim",
      status: true,
      value: 60,
    },
    {
      display: false,
      id: 5,
      name: "P_input_aim",
      status: true,
      value: 0,
    },
    {
      display: false,
      id: 6,
      name: "S_input_aim",
      status: true,
      value: 0,
    },
    {
      display: true,
      id: 7,
      name: "MgO_by_Al2O3_input_aim",
      status: true,
      value: 1.09,
    },
    {
      display: false,
      id: 8,
      name: "basicity_input_aim",
      status: true,
      value: 1.07,
    },
    {
      display: false,
      id: 9,
      name: "Cr_by_Fe_ore_aim",
      status: true,
      value: 2.5,
    },
    {
      display: false,
      id: 10,
      name: "input_CaO_aim",
      status: true,
      value: 23,
    },
    {
      display: true,
      id: 11,
      name: "LUMPS_plus_CHIPS_aim",
      status: true,
      value: 42.5,
    },
    {
      display: true,
      id: 12,
      name: "FBL_percent_aim",
      status: true,
      value: 7.5,
    },
    {
      display: true,
      id: 13,
      name: "COKE_CO_percent_aim",
      status: true,
      value: 85,
    },
    {
      display: true,
      id: 14,
      name: "COAL_AN_percent_aim",
      status: true,
      value: 15,
    },
  ],
  controllers: [
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 1,
      name: "population_size",
      status: true,
      value: 100,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 2,
      name: "mutation_probability",
      status: true,
      value: 0.3,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 3,
      name: "mutation_extent",
      status: true,
      value: 10,
    },
    {
      category: "TOP_CONTROLLERS",
      display: false,
      id: 4,
      name: "generations",
      status: true,
      value: 100,
    },
    {
      category: "LUMPS",
      id: 5,
      name: "LUMPS_BIN",
      status: true,
      value: 2,
    },
    {
      category: "LUMPS",
      id: 6,
      name: "LUMPS_LMG_TOTAL",
      status: true,
      value: 160,
    },
    {
      category: "LUMPS",
      id: 7,
      name: "LUMPS_LMG_TOLERANCE",
      status: true,
      value: 10,
    },
    {
      category: "LUMPS",
      id: 8,
      name: "LUMPS_LG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "LUMPS",
      id: 9,
      name: "LUMPS_LG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "CHIPS",
      id: 10,
      name: "CHIPS_BIN",
      status: true,
      value: 1,
    },
    {
      category: "CHIPS",
      id: 11,
      name: "CHIPS_LMG_TOTAL",
      status: true,
      value: 240,
    },
    {
      category: "CHIPS",
      id: 12,
      name: "CHIPS_LMG_TOLERANCE",
      status: true,
      value: 10,
    },
    {
      category: "CHIPS",
      id: 13,
      name: "CHIPS_LG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "CHIPS",
      id: 14,
      name: "CHIPS_LG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "FBL",
      id: 15,
      name: "FBL_BIN",
      status: true,
      value: 1,
    },
    {
      category: "FBL",
      id: 16,
      name: "FBL_HG_TOTAL",
      status: true,
      value: 100,
    },
    {
      category: "FBL",
      id: 17,
      name: "FBL_HG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "FBL",
      id: 18,
      name: "FBL_HMG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 19,
      name: "FBL_HMG_TOLERANCE",
      status: true,
      value: 10,
    },
    {
      category: "FBL",
      id: 20,
      name: "FBL_LMG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 21,
      name: "FBL_LMG_TOLERANCE",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 22,
      name: "FBL_LG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "FBL",
      id: 23,
      name: "FBL_LG_TOLERANCE",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 24,
      name: "COMPOSITE_BQT_BIN",
      status: true,
      value: 1,
    },
    {
      category: "BQT",
      id: 25,
      name: "NORMAL_BQT_BIN",
      status: true,
      value: 2,
    },
    {
      category: "BQT",
      id: 26,
      name: "BQT_HG_COMP_TOTAL",
      status: true,
      value: 150,
    },
    {
      category: "BQT",
      id: 27,
      name: "BQT_HG_COMP_TOLERANCE",
      status: true,
      value: 10,
    },
    {
      category: "BQT",
      id: 28,
      name: "BQT_HMG_COMP_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 29,
      name: "BQT_HMG_COMP_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 30,
      name: "BQT_LMG_COMP_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 31,
      name: "BQT_LMG_COMP_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 32,
      name: "BQT_LG_COMP_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 33,
      name: "BQT_LG_COMP_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 34,
      name: "BQT_HG_TOTAL",
      status: true,
      value: 233.75,
    },
    {
      category: "BQT",
      id: 35,
      name: "BQT_HG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 36,
      name: "BQT_HMG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 37,
      name: "BQT_HMG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 38,
      name: "BQT_LMG_TOTAL",
      status: true,
      value: 0,
    },
    {
      category: "BQT",
      id: 39,
      name: "BQT_LMG_TOLERANCE",
      status: true,
      value: 30,
    },
    {
      category: "BQT",
      id: 40,
      name: "BQT_LG_TOTAL",
      status: true,
      value: 191.25,
    },
    {
      category: "BQT",
      id: 41,
      name: "BQT_LG_TOLERANCE",
      status: true,
      value: 30,
    },
  ],
  steps: [
    {
      description: "Out of total LUMPS plus CHIPS aim",
      category: "LUMPS + CHIPS (Step2 - out of total lumps + chips quantity)",
      displayName: "LUMPS",
      id: 0,
      name: "LUMPS_STEP2",
      status: true,
      stepNumber: 2,
      value: 50,
    },
    {
      description: "Out of total Lumps & Chips Aim",
      category: "LUMPS + CHIPS (Step2 - out of total lumps + chips quantity)",
      displayName: "CHIPS",
      id: 1,
      name: "CHIPS_STEP2",
      status: true,
      stepNumber: 2,
      value: 50,
    },
    {
      description: "Out of total Lumps Qty of Burden",
      category: "LUMPS (Step3 - out of total lumps quantity)",
      displayName: "LMG_LUMPS",
      id: 2,
      name: "LMG_LUMPS_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total Lumps Qty of Burden",
      category: "LUMPS (Step3 - out of total lumps quantity)",
      displayName: "LG_LUMPS",
      id: 3,
      name: "LG_LUMPS_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total Chips Qty of Burden",
      category: "CHIPS (Step3 - out of total chips quantity)",
      displayName: "LMG_CHIPS",
      id: 4,
      name: "LMG_CHIPS_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total Chips Qty of Burden",
      category: "CHIPS (Step3 - out of total chips quantity)",
      displayName: "LG_CHIPS",
      id: 5,
      name: "LG_CHIPS_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total ore mix",
      category: "COMP BQT (Step3 - out of total ore mix)",
      displayName: "HG/HMG_COMP_BQT",
      id: 10,
      name: "HG_HMG_COMP_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 10,
    },

    {
      description: "Out of total ore mix",
      category: "COMP BQT (Step3 - out of total ore mix)",
      displayName: "LG/LMG_COMP_BQT",
      id: 12,
      name: "LG_LMG_COMP_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 0,
    },
    {
      description: "Out of total BRIQUETTE Qty of Burden",
      category: "BQT (Step3 - out of total bqt quantity of burden)",
      displayName: "HG/HMG_BQT",
      id: 6,
      name: "HG_HMG_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
    {
      description: "Out of total BRIQUETTE Qty of Burden",
      category: "BQT (Step3 - out of total bqt quantity of burden)",
      displayName: "LG/LMG_BQT",
      id: 8,
      name: "LG_LMG_BQT_STEP3",
      status: true,
      stepNumber: 3,
      value: 50,
    },
  ].map((el, idx) => ({ ...el, id: idx + 1 })),
  weightage_factors: [
    {
      display: false,
      id: 1,
      name: "FC_balance_percent_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 2,
      name: "SiO2_imbalance_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 3,
      name: "percent_SiO2_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 4,
      name: "reductant_purchase_cost_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 5,
      name: "Cr_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 6,
      name: "P_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 7,
      name: "S_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 8,
      name: "basicity_input_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 9,
      name: "Cr_by_Fe_ore_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 10,
      name: "too_much_CaO_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 11,
      name: "Lumps_plus_chips_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 12,
      name: "FBL_aim_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 13,
      name: "grade_balance_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 14,
      name: "Max_Lumps_ff",
      status: true,
      value: 1,
    },
    {
      display: false,
      id: 15,
      name: "Max_Chips_ff",
      status: true,
      value: 1,
    },
  ],
};
